import React, { Fragment, useRef, useState } from "react";
import dayjs from "dayjs";
import {
  _formatCurrency,
  _combineDateAndTime,
  _validateNumber,
} from "../../Utils/helpers";
import Avatar from "../Avatar";
import { LineMenuIcon } from "../Icons/Collections";
import SubMenu from "../../../src/Pipeline/SubMenu";
import Input from "../../../src/Resources/Forms/Input";
import Tag from "../../../src/Resources/Tag";
import Checkbox from "../../../src/Resources/Forms/Checkbox";
import Button from "../../../src/Resources/Forms/Button";
import Switch from "../../../src/Resources/Forms/Switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useWindowSize } from "../../Hooks/helpers";

const TableItem = (props) => {
  const menuRef = useRef(null);
  const checkboxRef = useRef(null);
  const switchRef = useRef(null);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");

  const windowSize = useWindowSize();

  const field = props.field;

  const subMenuOptions = getSubmenuOptions();

  function getSubmenuOptions() {
    //TODO: Refactor
    const result = props.subMenuOptions || [];
    const subMenuHideId = field[props.subMenuHideId || "subMenuHideId"];
    if (subMenuHideId) {
      return result.filter(
        (el) =>
          !el.hideId || !el.hideId.split(",").includes(subMenuHideId.toString())
      );
    }
    return result;
  }

  function handleClick(e) {
    if (menuRef.current && menuRef.current.contains(e.target)) {
      return;
    }

    if (checkboxRef.current && checkboxRef.current.contains(e.target)) {
      return;
    }

    if (switchRef.current && switchRef.current.contains(e.target)) {
      return;
    }

    if (props.showColumnExpand) {
      setShowDetails(false);
    }
    props.columnClick(field, e.target);
  }

  function onCheckboxChange(e) {
    props.onCheckboxChange(field);
  }
  function onSwitchChange(e) {
    props.onSwitchChange(field);
  }

  return (
    <Fragment>
      <div
        className={`bo-data-table-body-each ${
          props.columnClick ? "hover-highlight" : ""
        }`}
        onClick={(e) => (props.columnClick ? handleClick(e) : null)}
        style={{
          cursor: !props.columnClick ? "default" : "",
        }}
      >
        {props.columns.map((column, index) => {
          return (
            <div
              className={`bo-data-table-body-each-item ${
                column.classNames || ""
              } ${column.position === "center" ? "center-item" : ""} 
							${
                column.type === "tag" && typeof field[column.text] === "string"
                  ? field[column.text].toLowerCase()
                  : ""
              }`}
              key={index}
              style={{
                width: props.isMobile
                  ? ""
                  : props.showHorizontalScroll
                  ? `${props.getColumnWidth(index)}px`
                  : column.width
                  ? column.width + "px"
                  : `calc(100% - ${props.remainingWidth})`,
                minWidth: props.isMobile
                  ? ""
                  : props.showHorizontalScroll
                  ? `${props.getColumnWidth(index) - 7}px`
                  : column.width
                  ? column.width - 7 + "px"
                  : "",
              }}
            >
              {column.label && (
                <div
                  className={`datatable-field-item-label hide--desktop ${
                    column.labelClassNames || ""
                  }`}
                >
                  {column.label}
                </div>
              )}
              {column.isEditable ? (
                <Fragment>
                  <Input
                    size={"small"}
                    onKeyPress={(e) => _validateNumber(e)}
                    name={column.text}
                    value={field[column.text]}
                    onChange={(e) =>
                      props.onColumnValueChange(
                        e,
                        props.index,
                        column.text,
                        field
                      )
                    }
                    // disabled={
                    // 	(column.isDisabled && field.isDisabledTableField) || false
                    // }
                    errorText={field.errorText || ""}
                  />
                </Fragment>
              ) : column.isDatePicker ? (
                <div
                  style={{
                    position: "relative",
                  }}
                  className={`datepicker ${field.errorText && "date-error"}`}
                >
                  <DatePicker
                    selected={selectedDate}
                    onChange={(e) => {
                      props.onColumnValueChange(
                        e,
                        props.index,
                        column.text,
                        field
                      );
                      setSelectedDate(e);
                    }}
                    placeholderText={"MM-DD-YYYY"}
                    minDate={new Date()}
                    dateFormat="MM/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    popperPlacement="bottom-start"
                    showPopperArrow={false}
                    popperModifiers={{
                      flip: {
                        behavior:
                          windowSize.widthOuter > 1146
                            ? ["bottom", "right", "left"]
                            : ["bottom", "top"],
                      },
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                  {field.errorText && (
                    <span
                      style={{
                        position: "absolute",
                        fontSize: "11px",
                        color: "red",
                        bottom: "-17px",
                        width: "100%",
                        left: "0px",
                      }}
                    >
                      {field.errorText}
                    </span>
                  )}
                </div>
              ) : (
                <Fragment>
                  {!["", undefined, null].includes(field[column.text]) ? (
                    <Fragment>
                      {column.type === "date" ? (
                        dayjs(field[column.text]).isValid() ? (
                          dayjs(field[column.text]).format(
                            column.format || "MMM D, YYYY"
                          )
                        ) : (
                          "-"
                        )
                      ) : column.type === "currency" ? (
                        _formatCurrency(field[column.text])
                      ) : column.withAvatar ? (
                        <div className="flex align-center">
                          <div style={{ marginRight: "7px" }}>
                            <Avatar
                              isRandomBg
                              //isDarkColor
                              name={field[column.text]}
                              size={24}
                              color={"#fff"}
                            />
                          </div>
                          {field[column.text]}
                        </div>
                      ) : column.withCheckbox ? (
                        <div className="no-print" ref={checkboxRef}>
                          <Checkbox
                            checked={props.checkedRowIds.includes(
                              field.SKUCode ||
                                field.shipmentId ||
                                field[column.text]
                            )}
                            onChange={onCheckboxChange}
                            padding={"0px"}
                          />
                        </div>
                      ) : column.type === "image" ? (
                        <img
                          src={field[column.text]}
                          alt=""
                          title={column.title || ""}
                        />
                      ) : column.type === "time" ? (
                        _combineDateAndTime(
                          null,
                          field[column.text],
                          null,
                          true
                        )
                      ) : column.type === "switch" ? (
                        <div ref={switchRef}>
                          <Switch
                            noTrunc={true}
                            size={"small"}
                            position={"left"}
                            margin={"0px"}
                            light={true}
                            padding={"0px"}
                            checked={field[column.text] === 1 ? false : true}
                            value={field[column.text]}
                            onChange={onSwitchChange}
                          />
                        </div>
                      ) : column.type === "tag" ? (
                        <Tag
                          text={field[column.text]}
                          type={field.tableTagType || ""}
                        />
                      ) : column.text === "isPaylaterIncluded" &&
                        field[column.text] === 1 ? (
                        <span>
                          <div className="paylater">
                            <p>{"PayLater Included"}</p>
                          </div>
                        </span>
                      ) : column.text === "isPaylaterIncluded" &&
                        field[column.text] === 0 ? (
                        ""
                      ) : (
                        field[column.text]
                      )}
                      {column.suffix ? ` ${column.suffix}` : ""}
                      {column.extraColumns && column.extraColumns.length > 0 && (
                        <div className={column.extraColumnClassNames}>
                          {column.extraColumns.map((extraColumn, i) => (
                            <div key={i} className={extraColumn.classNames}>
                              {field[extraColumn.text]}
                            </div>
                          ))}
                        </div>
                      )}
                    </Fragment>
                  ) : (
                    props.emptyColumnText || ""
                  )}
                </Fragment>
              )}
            </div>
          );
        })}
        {(subMenuOptions.length > 0 || props.showColumnExpand) && (
          <div className="bo-data-table-body-each-item bo-data-table-body-each-item-menu">
            {props.showColumnExpand ? (
              <span ref={menuRef} onClick={() => setShowDetails(!showDetails)}>
                <img src={"Images/down-arrow.svg"} alt="" />
              </span>
            ) : (
              <span
                ref={menuRef}
                onClick={() => setShowSubmenu(true)}
                className="no-print"
              >
                <LineMenuIcon
                  color={"#232f49"}
                  height={"15px"}
                  width={"15px"}
                />
              </span>
            )}
          </div>
        )}

        {props.showColumnButton &&
          Object.keys(props.showColumnButton).length > 0 && (
            <div className="bo-data-table-body-each-item bo-data-table-body-each-item-button">
              <Button
                size={"small"}
                type={props.showColumnButton.type}
                text={props.showColumnButton.text}
                onClick={() =>
                  props.showColumnButton &&
                  props.showColumnButton.onClick(field)
                }
              />
            </div>
          )}
      </div>
      {showSubmenu && (
        <SubMenu close={() => setShowSubmenu(false)} target={menuRef.current}>
          {subMenuOptions.map((el, i) => (
            <div
              className="submenu-option"
              key={i}
              onClick={() => el.onClick && el.onClick(field)}
            >
              {el.text}
            </div>
          ))}
        </SubMenu>
      )}
      {showDetails && (
        <div className="bo-data-table-body-each-details">
          {props.extraColumns.map((column, index) => (
            <div
              className={`${column.classNames || ""}`}
              key={index}
              style={{}}
            >
              {column.label && (
                <div className={`${column.labelClassNames || ""}`}>
                  {column.label}
                </div>
              )}
              {!["", undefined, null].includes(field[column.text]) ? (
                <Fragment>
                  {column.type === "date" ? (
                    dayjs(field[column.text]).isValid() ? (
                      dayjs(field[column.text]).format(
                        column.format || "MMM D, YYYY"
                      )
                    ) : (
                      "-"
                    )
                  ) : column.type === "currency" ? (
                    _formatCurrency(field[column.text])
                  ) : column.withAvatar ? (
                    <div className="flex align-center">
                      <div style={{ marginRight: "7px" }}>
                        <Avatar
                          isRandomBg
                          //isDarkColor
                          name={field[column.text]}
                          size={24}
                          color={"#fff"}
                        />
                      </div>
                      {field[column.text]}
                    </div>
                  ) : column.type === "image" ? (
                    <img src={field[column.text]} alt="" />
                  ) : column.type === "time" ? (
                    _combineDateAndTime(null, field[column.text], null, true)
                  ) : (
                    field[column.text]
                  )}
                  {column.suffix ? ` ${column.suffix}` : ""}
                  {column.extraColumns && column.extraColumns.length > 0 && (
                    <div className={column.extraColumnClassNames}>
                      {column.extraColumns.map((extraColumn, i) => (
                        <div key={i} className={extraColumn.classNames}>
                          {field[extraColumn.text]}
                        </div>
                      ))}
                    </div>
                  )}
                </Fragment>
              ) : (
                props.emptyColumnText || ""
              )}
            </div>
          ))}
        </div>
      )}
    </Fragment>
  );
};

export default TableItem;
